<script>
import { mapState, mapActions, mapGetters } from "vuex";
import currencyMixin from "@/mixins/generic/currencyMixin";

export default {
  mixins: [currencyMixin],
  methods: {
    ...mapActions("requireProductsPreference", ["setAnswer", "getPricing"]),
    ...mapActions("orderScheduler", ["setShouldIncludeProducts"]),
    setFirstOption() {
      if (this.configurableFieldOptions.length < 1) return;

      const noOption = this.configurableFieldOptions.find(
        option => option.key === "NO"
      );

      this.handleAnswerChange(noOption);
    },

    handleAnswerChange(option) {
      this.setShouldIncludeProducts(option.key === "YES");
      this.setAnswer(option.opt_id);
    }
  },

  computed: {
    ...mapState("requireProductsPreference", [
      "configurableField",
      "configurableFieldOptions",
      "answer",
      "productsPricing"
    ]),
    ...mapGetters("orderScheduler", ["duration"])
  },

  async mounted() {
    this.setFirstOption();

    await this.getPricing();
  }
};
</script>

<template>
  <div class="preference" v-if="productsPricing">
    <div class="column flex-1">
      <div class="row">
        <p>{{ configurableField.display_name }}</p>
      </div>
      <div class="row radio-item" v-for="option in configurableFieldOptions" :key="option.id">
        <label>
          <input type="radio"
            :name="option.display_name"
            :value="option.opt_id"
            :checked="option.opt_id == answer"
            @change="handleAnswerChange(option)">
          <span> {{ option.display_name }} {{ option.opt_id === 1 ? `(+ ${$options.filters.toCurrency(productsPricing.fee + productsPricing.price + ((productsPricing.fee_per_hour + productsPricing.price_per_hour) * duration))})` : '' }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<style scoped>
.preference {
  width: 100%;
  font-size: 13px;
  margin-bottom: 20px;
  color: var(--purple);
  display: flex;
}

.preference .column {
  align-items: center;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
}

@media (max-width: 365px) {
  .preference .column {
    align-items: flex-start;
  }
}

.preference p {
  margin-bottom: 0px;
}

.preference label {
  display: block;
  white-space: normal;
  text-align: start;
}

.preference label span {
  vertical-align: middle;
  font-size: 14px;
  font-weight: 300;
}

.preference input {
  vertical-align: middle;
  border: 0px;
  margin-top: 0px;
}

.preference label > input[type="radio"] {
  display: none;
}

.preference label > input[type="radio"] + *::before {
  content: "";
  display: inline-block;
  vertical-align: bottom;
  width: 0.7rem;
  height: 0.7rem;
  margin-right: 0.3rem;
  margin-bottom: 0.1rem;
  border-radius: 50%;
  border-style: solid;
  border-width: 0.1rem;
  border-color: gray;
}

.preference label > input[type="radio"]:checked + *::before {
  background: var(--purple);
  border-color: var(--purple);
}

.preference label > input[type="radio"] + * {
  display: inline-block;
  padding-top: 8px;
}

.row {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Confirmation/ProductsPreference.vue